import Slider from "react-slick";
import { Container, Fade } from "react-bootstrap";
import "./carousel.css";
import Entry from "../../images/company/office-entry.webp";
import InteriorView1 from "../../images/company/interior-1.webp";
import InteriorView2 from "../../images/company/interior-2.webp";
import Reception from "../../images/company/reception.webp";

const testimonials = [
    {
        imgSrc: Entry,
    },
    {
        imgSrc: InteriorView1,
    },
    {
        imgSrc: InteriorView2,
    },
    {
        imgSrc: Reception,
    },
];

const OfficeCarousel = () => {
    const officeCarousel = {
        dots: false,
        infinite: true,
        fade: true,
        speed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
    };

    return (
        <section className="px-0">
            <Container fluid>
                <Slider {...officeCarousel} className="testimonial-carousel">
                    {testimonials.map((testimonial, index) => (
                        <div className="pt-50" key={index}>
                            <img src={testimonial.imgSrc} alt="office-img" loading="lazy" />
                        </div>
                    ))}
                </Slider>
            </Container>
        </section>
    );
};

export default OfficeCarousel;
